import { Observable} from "rxjs";

/**
 * A function that returns an agument value.
 */
export type LoaderArgumentGetter = ( forceReload?: boolean ) => any;


/**
 * A dictionary of functions that returns arguments values. So basically it is an
 * object with named arguments, where each argument is not a value, but a function
 * that returns the value.
 */
export type LoaderArgumentsMap = _.Dictionary<LoaderArgumentGetter>;


/**
 * Eigher single function that returns an argument's value, or a dictionary of such getters.
 */
export type LoaderArguments = ( LoaderArgumentGetter | LoaderArgumentsMap )[];


/**
 * Function that initiates data loading and returns a promise.
 */
export type LoaderCallback<TResult = any> = ( ...args: any[] ) => Observable<TResult>;


/**
 * Definition of a data loader.
 */
export interface LoaderConfiguration<TResult = any> {

    /**
     * Dictionary of arguments values getters.
     */
    args?: LoaderArguments;

    /**
     * Specifies that this loader requires other loaders to be executed first.
     */
    require?: string[];

    /**
     * Loading function.
     */
    loader: LoaderCallback<TResult>;

    /**
     * Loading function.
     */
    noCache?: boolean;

    /**
     * Result of the loading gets stored internally. Later, if dataset arguments have not changed
     * then stored result will be returned.
     */
    storeResult?: boolean;

    /**
     * Number of milliseconds to wait before executing the loader. Default is 0.
     */
    delay?: number;
}
